import { Product } from './types'

// Nomenclator de produse predefinite - template-uri pentru adăugare rapidă
export const productNomenclator: Omit<
  Product,
  'id' | 'created_at' | 'modified_at' | 'start_date' | 'end_date' | 'images'
>[] = [
  {
    format: 'billboard',
    location_name: 'Billboard Standard',
    address: 'Chișinău',
    internal_code: 'BB-STD-001',
    gps_coordinates: undefined,
    net_cost: 2000,
    gross_cost: 2500,
    discount: 0,
    additional_costs: {
      tipar: 300,
      montaj: 150,
      demontaj: 100
    },
    supplier_name: 'Media Solutions SRL',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '3000x2000px',
      delivery_time: '5 zile lucrătoare',
      limitations: 'Format JPG/PNG, max 10MB'
    }
  },
  {
    format: 'citylight',
    location_name: 'Citylight Standard',
    address: 'Chișinău',
    internal_code: 'CL-STD-001',
    gps_coordinates: undefined,
    net_cost: 1500,
    gross_cost: 1800,
    discount: 0,
    additional_costs: {
      tipar: 200,
      montaj: 100
    },
    supplier_name: 'Outdoor Advertising MD',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '3 zile lucrătoare',
      limitations: 'Format RGB, max 5MB'
    }
  },
  {
    format: 'prismatron',
    location_name: 'Prismatron Standard',
    address: 'Chișinău',
    internal_code: 'PR-STD-001',
    gps_coordinates: undefined,
    net_cost: 3000,
    gross_cost: 3500,
    discount: 0,
    additional_costs: {
      tipar: 400,
      montaj: 200,
      demontaj: 150
    },
    supplier_name: 'Digital Media Pro',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '3840x2160px',
      delivery_time: '7 zile lucrătoare',
      limitations: 'Format MP4, max 50MB, durată max 30s'
    }
  },
  {
    format: 'perete',
    location_name: 'Perete Standard',
    address: 'Chișinău',
    internal_code: 'PE-STD-001',
    gps_coordinates: undefined,
    net_cost: 1200,
    gross_cost: 1500,
    discount: 0,
    additional_costs: {
      tipar: 250,
      montaj: 120
    },
    supplier_name: 'Regional Advertising',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '2400x3200px',
      delivery_time: '4 zile lucrătoare',
      limitations: 'Format JPG, max 8MB'
    }
  },
  {
    format: 'billboard_nestandart',
    location_name: 'Billboard Nestandard',
    address: 'Chișinău',
    internal_code: 'BB-NS-001',
    gps_coordinates: undefined,
    net_cost: 4000,
    gross_cost: 4800,
    discount: 0,
    additional_costs: {
      tipar: 500,
      montaj: 250,
      demontaj: 200
    },
    supplier_name: 'Airport Media',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '4000x3000px',
      delivery_time: '10 zile lucrătoare',
      limitations: 'Format JPG/PNG, max 15MB'
    }
  },
  {
    format: 'console',
    location_name: 'Console Standard',
    address: 'Chișinău',
    internal_code: 'CO-STD-001',
    gps_coordinates: undefined,
    net_cost: 1800,
    gross_cost: 2200,
    discount: 0,
    additional_costs: {
      tipar: 300,
      montaj: 150
    },
    supplier_name: 'Mall Advertising',
    payment_terms: 'postfactum',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '5 zile lucrătoare',
      limitations: 'Format RGB, max 6MB'
    }
  },
  {
    format: 'ceasuri',
    location_name: 'Ceasuri Digital',
    address: 'Chișinău',
    internal_code: 'CE-STD-001',
    gps_coordinates: undefined,
    net_cost: 2500,
    gross_cost: 3000,
    discount: 0,
    additional_costs: {
      tipar: 0,
      montaj: 100
    },
    supplier_name: 'Digital Displays MD',
    payment_terms: 'avans',
    technical_policies: {
      file_dimensions: '1920x1080px',
      delivery_time: '3 zile lucrătoare',
      limitations: 'Format MP4, max 20MB, durată max 15s'
    }
  }
]
